import React from "react";

const skillImages = require.context('../../images/skills', false);
const skillPaths = skillImages.keys();

function Skills() {
    return (
        <div className="skills-container">
            <div className="d-flex skills-header">
                <h2>Skills</h2><h2 className="code-sign">{"</>"}</h2>
            </div>
            <div className="skills-grid">
                {skillPaths.map((imagePath, idx) => {
                    const fileName = imagePath
                        .replace(/^.*[\\/]/, '')
                        .replace(/\.[^/.]+$/, '')
                        .replace(/-/g, ' ');
                    return (
                        <div className="skill-card" key={idx + imagePath}>
                            <img src={skillImages(imagePath)} alt={fileName} />
                            <span>{fileName}</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default Skills;